import {
    getData,
} from './Services'

export const getRubros = async () => {
    const res = await getData('/rubros/rubros_select');
    return res
}

